/**
 * Newsletter-Dialog ohne externe Bibliothek.
 * sessionStorage merkt nur innerhalb des aktuellen Browser-Tabs, dass das Fenster
 * bereits gezeigt/geschlossen wurde. Es werden keinerlei E-Mail-Adressen gespeichert.
 * Native Shopify-Formulare bleiben für Versand, Fehler und Spam-Schutz zuständig.
 */
(() => {
  const dialog = document.querySelector('[data-newsletter-dialog]');
  const seenKey = 'ar462-newsletter-seen-v1';
  const pendingKey = 'ar462-newsletter-pending-v1';
  // Storage kann im Privatmodus gesperrt sein; das Formular muss trotzdem funktionieren.
  const read = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  const remove = (key) => { try { sessionStorage.removeItem(key); } catch {} };
  let previousFocus = null;
  const openDialog = () => {
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
    // Keine konkurrierenden Warenkorb-, Konto- oder Cookie-Dialoge überdecken.
    const competingModal = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some((element) => element !== dialog && element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true');
    if (competingModal) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('ar462-newsletter-open');
    write(seenKey, '1');
  };
  const pendingFormId = read(pendingKey);
  document.querySelectorAll('.ar462-newsletter-form').forEach((form) => {
    form.addEventListener('submit', () => {
      // submit wird erst nach erfolgreicher Browser-Pflichtfeldprüfung ausgelöst.
      write(pendingKey, form.id);
      write(seenKey, '1');
    });
    if (form.id === pendingFormId && form.querySelector('[data-newsletter-result]')) {
      remove(pendingKey);
      if (form.closest('dialog')) openDialog();
      else {
        form.scrollIntoView({ block: 'center' });
        form.querySelector('[data-newsletter-result]')?.focus();
      }
    }
  });
  if (!dialog) return;
  dialog.querySelectorAll('[data-newsletter-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });
  dialog.addEventListener('click', (event) => {
    // Nur ein Klick außerhalb der tatsächlichen Dialogfläche schließt den Backdrop.
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('ar462-newsletter-open');
    write(seenKey, '1');
    if (previousFocus?.isConnected) previousFocus.focus();
  });
  // 6 Sekunden Pause nach Seitenaufbau; bei späteren Seitenwechseln im Tab bleibt es geschlossen.
  if (!read(seenKey) && !window.Shopify?.designMode) {
    window.setTimeout(() => {
      if (!document.hidden && !document.activeElement?.matches('input, textarea, select')) openDialog();
    }, 6000);
  }
})();
